export default __webpack_public_path__ + "static/media/img-0670-albania-half-face.fe4c1f12.png";